const mutations = {
  onGet (state, payload) {
    let data = payload.response.data.data
    let companies = data
    if (companies.data) {
      payload.event.context.options.totalItems = data.total
      payload.event.context.options.page = data.current_page
      companies = data.data
    }
    if (!Array.isArray(companies)) {
      companies = new Array(companies)
    }
    payload.event.context.companies = companies
    payload.event.context.loadingTable = false
  },
  onGetCompanyBySuperAdmin (state, payload) {
    let data = payload.response.data.data
    let companies = data
    if (companies.data) {
      companies = data.data
    }
    if (!Array.isArray(companies)) {
      companies = new Array(companies)
    }
    payload.event.context.companies = companies
    payload.event.context.loadingTable = false
  },
  onGetById (state, payload) {
    let data = payload.response.data.data
    let company = {
      custom_report: data.settings.custom_report,
      custom_questionnaire: data.settings.custom_questionnaire,
      timezone: data.timezone,
      logo_id: data.logo_id,
      name: data.name,
      phone: data.phone,
      tax_regimen: data.tax_regimen,
      tax_id: data.tax_id,
      bussiness_name: data.bussiness_name,
      address: {
        street: data.address.street,
        street_number: data.address.street_number,
        suburb: data.address.suburb,
        city: data.address.city,
        state: data.address.state,
        country_id: data.address.country_id,
        zip_code:data.address.zip_code
      }
    }
    payload.event.context.company = Object.assign({}, company)
    payload.event.context.show = true
    payload.event.context.loading = false
    if (company.logo_id) {
      payload.event.context.getFile()
    }
  },
  onPost (state, payload) {
    payload.event.context.showNotification(payload.response.data.message, 'success')
    payload.event.context.redirect()
  },
  onPut (state, payload) {
    payload.event.context.showNotification(payload.response.data.message, 'success')
    payload.event.context.redirect()
  },
  onUpdateOwn (state, payload) {
    payload.event.context.showNotification(payload.response.data.message, 'success')
    payload.event.context.loading = false
    payload.event.context.closeCompany()
    payload.event.context.getUserLogged()
  },
  onDelete (state, payload) {
    payload.event.context.showNotification(payload.response.data.message, 'success')
    payload.event.context.get()
  },
  /**
   * Recibe el objeto de la lista de cuestionarios
   * Se crea array para cada tipo de cuestionario (predeterminado y personalizado)
   * @param {Object} state Objeto del Storage
   * @param {Object} payload Objeto enviado desde el commit por el actions
   */
  onGetChecklist (state, payload) {
    let data = payload.response.data.data
    let checklist = []
    let pdf = []
    for (let item in data.custom_questionnaire) {
      checklist.push({ value: `${item}`, description: `${data.custom_questionnaire[item]}`})
    }
    for (let item in data.custom_report) {
      pdf.push({ value: `${item}`, description: `${data.custom_report[item]}`})
    }
    payload.event.context.defaultChecklist = checklist
    payload.event.context.formatPDF = pdf
  }
}

export default mutations